import { TableCell } from '@/components/ui/table';
import { formatPercentage } from '@/utils/format/number';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type SOHCellProps = {
  row: UnitOverviewRow;
};

export function SOHCell({ row }: SOHCellProps) {
  return (
    <TableCell narrow justify="left">
      {row.soh ? formatPercentage(row.soh, 0, 5) : '-'}
    </TableCell>
  );
}
